export const USERNAME_DOMAIN = "@capsdac.org";
export function buildUsernameParts(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  vendorNumber: string | number | null | undefined
): { editablePrefix: string; lockedSuffix: string; full: string } {
  const firstInitial = (firstName ?? "").trim().charAt(0);
  const cleanLast = (lastName ?? "").trim().replace(/\s+/g, "");
  const editablePrefix = `${firstInitial}${cleanLast}`;
  const lockedSuffix = `${vendorNumber ?? ""}${USERNAME_DOMAIN}`;
  return {
    editablePrefix,
    lockedSuffix,
    full: `${editablePrefix}${lockedSuffix}`,
  };
}

export function isUsernameTaken(
  fullUsername: string,
  users: Array<{ userName?: string | null }>
): boolean {
  const target = fullUsername.trim().toLowerCase();
  if (!target) return false;
  return users.some((u) => (u.userName ?? "").trim().toLowerCase() === target);
}

export function sanitizeUsernamePrefix(value: string): string {
  return value.replace(/[\s@]/g, "");
}
